export class SDKDataGridMessage {
    public Title: string = "";
    public Text: string =  "";
    public OKText: string =  "";
    public CancelText?: string =  "";
    public OK: any = () => {};
    public Cancel?: any = () => {};
}
